import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {NotificationService} from '@services/notification/notification.service';
import {GatewayService} from '@services/administration/gateway/gateway.service';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';

import {Gateway} from '@models/adminstration/gateway/gateway';
import {GatewaySignals} from '@models/adminstration/gateway/gateway-configuration/gateway-signals';

import {ActivatedRoute} from '@angular/router';
import {switchMap} from 'rxjs';
import {utob} from '@prototypes/global.functions';

@Component({
    selector: 'scitis-admin-gateway-connections',
    templateUrl: './gateway-connections.component.html',
    styleUrls: ['./gateway-connections.component.scss'],
    standalone: false
})
export class GatewayConnectionsComponent implements OnInit {

  activeTab = 1;

  @Input()
  gateway: Gateway = new Gateway();

  @Input()
  isEditable: boolean = false;

  @Input()
  isCPOneGateway: boolean = false;

  @Input()
  isCPEdgeGateway: boolean = false;

  @Input()
  isArgosGateway: boolean = false;

  @Input()
  isCPSoftGateway: boolean = false;

  @Input()
  isGenericGateway: boolean = false;

  @Input()
  superOrTechAdminRole: boolean = false;

  @Input()
  isAdminOrHigher: boolean = false;

  arraysConfigChanged: boolean = false;
  gatewaySignals: GatewaySignals[] = new Array<GatewaySignals>();
  private COMPONENT_NAME = 'GatewayConnectionsComponent';
  public isEavViewFeatureEnabled: boolean = false;
  public isStreamingEventDataToPubSubFeatureEnabled: boolean = false;

  constructor(private gatewayService: GatewayService,
              private loadingIndicator: LoadingIndicatorService,
              private translate: TranslateService,
              private notification: NotificationService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.loadingIndicator.show(this.translate.instant('loading configuration'));
    this.gateway.id === '' ? this.setConfigsReload() : this.setConfigs();
    this.setEavViewFlag();
    this.setStreamingEventsToPubSubFlag();
  }

  onSaveArrays() {
    this.loadingIndicator.show(this.translate.instant('saving arrays configuration'));
    const successMessage = 'Arrays configuration saved.';
    const errorMessage = 'Arrays configuration could not be saved.';
    this.saveConfiguration(successMessage, errorMessage, this.gatewaySignals, this.gateway.id);
  }

  public setConfigs() {
    this.gatewayService.getGatewaySignals(this.gateway.id).subscribe({
      next: (signals: any[]) => {
        if (signals?.length) {
          for (const element of signals) {
            if (element.values) {
              for (const val of element.values) {
                val.aliasEditClass = 'form-inline-edit-inactive';
              }
            }
            this.gatewaySignals = [...this.gatewaySignals, element];
          }
        }
        this.loadingIndicator.hide();
      }, error: (error) => {
        this.notification.error(this.translate.instant('Error setting Configurations.'), error, this.COMPONENT_NAME, true);
        this.loadingIndicator.hide();
      }
    });
  }

  private saveConfiguration(successMessage: string, errorMessage: string, gatewaySignals: GatewaySignals[], gatewayId: string): void {
    this.gatewayService.saveGatewayConnection(gatewayId, gatewaySignals).subscribe({
      next: (success) => {
        gatewaySignals = success;
        this.notification.success(this.translate.instant(successMessage), this.COMPONENT_NAME, false);
        this.loadingIndicator.hide();
        this.arraysConfigChanged = false;
      }, error: (error) => {
        this.notification.error(this.translate.instant(errorMessage), error, this.COMPONENT_NAME, true);
        this.loadingIndicator.hide();
        this.arraysConfigChanged = true;
      }
    });
  }

  private setConfigsReload() {
    const details = this.activatedRoute.snapshot.paramMap.get('details');
    if (details) {
      const parsed = JSON.parse(utob(details));
      this.gatewayService.getGatewayDetails(parsed.id).pipe(
          switchMap((gateway: any) => {
            this.gateway = gateway;
            return this.gatewayService.getGatewaySignals(this.gateway.id);
          })
      ).subscribe({
        next: (signals: any[]) => {
          if (signals?.length) {
            for (const element of signals) {
              if (element.values) {
                for (const val of element.values) {
                  val.aliasEditClass = 'form-inline-edit-inactive';
                }
              }
              this.gatewaySignals = [...this.gatewaySignals, element];
            }
          }
          this.loadingIndicator.hide();
        },
        error: (error) => {
          this.notification.error(this.translate.instant('Error setting Configurations.'), error, this.COMPONENT_NAME, true);
          this.loadingIndicator.hide();
        }
      });
    }
  }

  private setEavViewFlag(): void {
    this.gatewayService.isEavViewFeatureEnabled().subscribe({
      next: (result) => {
        if (result && result.length > 0) {
          this.isEavViewFeatureEnabled = result[0];
        } else {
          this.isEavViewFeatureEnabled = false;
        }
      }, error: (error) => {
        console.log('Error verifying if eav View creation feature is enabled', JSON.stringify(error));
        this.isEavViewFeatureEnabled = false;
      }
    });
  }

  private setStreamingEventsToPubSubFlag(): void {
    if (!this.isArgosGateway) {
      this.isStreamingEventDataToPubSubFeatureEnabled = false;
    }
    this.gatewayService.isStreamingEventDataToPubSubFeatureEnabled().subscribe({
      next: (result) => {
        if (result && result.length > 0) {
          this.isStreamingEventDataToPubSubFeatureEnabled = result[0];
        } else {
          this.isStreamingEventDataToPubSubFeatureEnabled = false;
        }
      }, error: (error) => {
        console.log('Error verifying if streaming event data to pub sub feature is enabled', JSON.stringify(error));
        this.isStreamingEventDataToPubSubFeatureEnabled = false;
      }
    });
  }

}
